export default "__VITE_ASSET__DRNGkbPZ__"